import { useCallback } from 'react';
import { GetMeQuery } from '@/generated/gql/graphql';
import useEnableUnification from '@/enterprise/components/useEnableUnification';
import useUserDetails from '@/shared/data/useUserDetails';
import useAccountFeatureConfigs from '@/shared/providers/useAccountFeatureConfigs';

// Unification go-live date for Low Spot enterprise accounts
export const ENTERPRISE_LOW_SPOT_UNIFICATION_DATE = '2026-04-28T00:00:00Z';
// Unification go-live date for Sweet Spot enterprise accounts
export const ENTERPRISE_SWEET_SPOT_UNIFICATION_DATE = '2026-06-01T00:00:00Z';

/**
 * Returns the date from which 'unified' state begins for this account:
 * SMB-migrated accounts use their actual migration date; enterprise accounts
 * use their segment's go-live date; non-unified accounts return null.
 */
export function useEffectiveUnificationDate(): string | null {
  const { wasSmbMigrated, migratedFromSmbDate } = useAccountFeatureConfigs();
  const isUnified = useEnableUnification();
  const { data: segment } = useUserDetails(useCallback(({ me }: GetMeQuery) => me?.account?.segment, []));

  if (wasSmbMigrated && migratedFromSmbDate != null) {
    return migratedFromSmbDate;
  }

  if (isUnified) {
    return segment === 'Low' ? ENTERPRISE_LOW_SPOT_UNIFICATION_DATE : ENTERPRISE_SWEET_SPOT_UNIFICATION_DATE;
  }

  return null;
}
